<template>
  <div class="detail-wrapper">
    <!--智齿客服-->
    <div class="fixed-kefu" v-if='showbottomkefu' @click="goZhichi">
      <img class="zhichi-img" src="../../../static/images/zhichi.png">
    </div>
    <!--强提醒-->
    <div class="config_mask" v-if="strongtip">
      <div class="config_content">
        <p class="config_title">
          <!--加群领资料-->
          <img  v-if='isweixin' @click="strongtip = false" src="../../../static/images/guanbi.png">
        </p>
        <div class="config_detail">
          <div class="out_loop" v-for="i in strongwxlist">
            <!--<p  class="cid_name">{{i.name}}</p>-->
            <p v-if='isweixin' class="warn_mes">{{i.remark}}</p>
            <div class="weixin_img">
              <img class="img_link" :src="i.qr">
              <img v-if='isweixin' class="hand" src="../../../static/images/hand.png">
            </div>
            <p v-if='isweixin' class="wenan">微信扫码 邀你进群</p>
            <div v-if='!isweixin' class="go_wxapp_btn" @click="goWxapp(i.qr)">{{i.buttonName || '点击添加微信'}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--会员卡弹窗提醒-->
    <div class="member-wrapper" v-if="!strongtip && isMember">
      <div class="member-content">
        <p class="kf_title">微信客服<img @click="isMember = false" src="../../../static/images/cancel.png"></p>
        <p class="kf_content">务必添加专属客户经理，<br/>以保证享受会员服务</p>
        <img class="member_img" :src="wxQrcode">
        <p>使用微信扫码添加</p>
      </div>
    </div>




    <div class="header" v-if="isapplets">
      <span class="give" v-if="dataList.isGiveCourse == 1" @click="isshare = true"><img src="../../../static/images/give.png"></span>
      <p class="top_title" v-if="istitle">{{dataList.order_name}}</p>
    </div>
    <section v-if='dataList'>
      <div class="live_options">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(i, index) in calendarList" :key="index" @click='go_zhibo(i)'>
              <p><img v-if="new Date().getTime() < ((i.start_time-600)*1000)" src="../../../static/images/jijiangkaishi.png">
                 <img v-else-if="new Date().getTime() > ((i.end_time-0+600)*1000)" src="../../../static/images/yijieshu.png">
                 <img v-else src="../../../static/images/zhibozhong.png">
                <span class="livetipname">{{i.lesson_name}}{{i.package_name}}</span>
              </p>
              <img class="poster" src="../../../static/images/default.png">
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div v-if="calendarList.length == 0"><div v-if='dataList.picture' class="banner"><img :src="dataList.picture"></div></div>
      <div class="title-box">
        <span v-if='again' @click="back_shop" class="buy_again">{{dataList.allowRepeatText || '再次购买'}}</span>
        <div class="title" @click="back_shop">{{dataList.order_name}}</div>
        <div class="online_time" v-if="dataList.leaf==1">
          <span v-if="level_count">{{level_count}}个课件</span><span v-if="hour"> | {{hour}}个课时</span><span v-if="online_time"> | {{online_time}}</span>
        </div>
        <div class="goumai_time">购买时间：{{dataList.createdAt}}<span class="qihuan_time" @click="change" v-if="changeshop">切换<img src="../../../static/images/change.png"></span></div>
        <div :class="[{'show':!isShow},'opening-time']" v-if="dataList.open_course_remark">
          {{dataList.open_course_remark}}
          <span class="text_overflow" @click="show" v-if="dataList.open_course_remark&&dataList.open_course_remark.length>60">
            <span>{{isShow==true?'收起':'展开'}}</span>
            <van-icon name="arrow-down" color="#999" v-if="!isShow" />
            <van-icon name="arrow-up" color="#999" v-if="isShow" />
          </span>
        </div>
      </div>
      <liveTip :config='configList' :isLiveTip="isLiveTip" :remind='remind' :msg_introduce='introduce'></liveTip>
      <p class="tab_margin"></p>
      <div class="tab-box" ref="obtain">
        <div class="tabs" v-if="isapplets" :class="{'fixed': isfixed}">
          <span
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: currentIndex == index }"
            @click="changeIndex(index)"
            v-show="item.show"
          >{{ item.value }}</span>
        </div>
        <div class="tabs" v-else :class="{'fixeds': isfixed}">
          <span
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: currentIndex == index }"
            @click="changeIndex(index)"
            v-show="item.show"
          >{{ item.value }}</span>
        </div>
        <div class="content">
          <addGroup v-if="currentIndex == 0" :config='configList' :isLiveTip="isLiveTip" :remind='remind' :msg_introduce='introduce'></addGroup>
          <onlineCourse v-if="currentIndex == 0&&dataList.leaf==0" :dataList="dataList.list" :currentIndex='currentIndex'></onlineCourse>
          <leaf v-if="currentIndex == 0&&dataList.leaf==1" :dataList="dataList.list"></leaf>
          <courseInfo v-if="currentIndex == 1" :dataList="dataList.courseIntroduction"></courseinfo>
          <coursePackage v-if="currentIndex == 2" :config="configList" :strongtip='strongtip' :strongwxlist='strongwxlist'></coursePackage>
          <moreCourses v-if="currentIndex == 3" :currentIndex = currentIndex :numberGoodsId = 'numberGoodsId'></moreCourses>
        </div>
      </div>
    </section>
    <div v-if="dataList.goodsId != 'wp0152111231528081001' && !hideFooter">
      <div class="footer" v-if="show_flag&&!isShowFlag&&!isapplets">
        <span class="bottom_text"><img @click="close_bottom" src="../../../static/images/bottom.png">
          <span>使用APP听课更流畅，更高效的用户体验<br/>点击按钮升级到APP最新版本,尽享更多惊喜!</span>
        </span>
        <p>
          <a class="footer_btns" @click="opentk">打开APP</a>
          <!-- <a class="footer_btns" :href="'https://www.eoffcn.com/zg_jiaoyu/detail?orderSn=' + detail.order_id + '&package_id=' + detail.package_id + '&cid=' + detail.cid + '&menu_id=' + detail.menu_id
            + '&spuID=' + detail.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' + this.$route.query.orgn" v-if="detail">打开APP</a>
          <a class="footer_btns" href="https://www.eoffcn.com/zg_jiaoyu/detail" v-else>打开APP</a> -->
        </p>
      </div>
      <div class="footer" v-else-if="show_flag&&!isShowFlag&&android&&isapplets">
        <span class="bottom_text"><img @click="close_bottom" src="../../../static/images/bottom.png">
          <span>使用APP听课更流畅，更高效的用户体验<br/>点击按钮升级到APP最新版本,尽享更多惊喜!</span>
        </span>
        <p>
          <a v-if='sf!="zgyc" && sf!="zgjsgc"' :href="scheme +'?type=1&sso_id='+ sso_id +'&orderSn='+ sn + '&spuID='+ dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" class="footer_btns" @click='search_flag'>打开APP</a>
          <a v-else :href='open_url' class="footer_btns">打开APP</a>
        </p>
      </div>
      <div class="footer" v-else-if="show_flag&&!isShowFlag&&ios&&isapplets">
        <span class="bottom_text"><img @click="close_bottom" src="../../../static/images/bottom.png">
          <span>使用APP听课更流畅，更高效的用户体验<br/>点击按钮升级到APP最新版本,尽享更多惊喜!</span>
        </span>
        <p>
          <a class="footer_btns" @click='search_flag'>打开APP</a>
        </p>
      </div>
    </div>
    <popup :data='detail' :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <div class="buyshop_time" v-if='option'>
      <div class="mask_content">
        <van-picker class="time_picker" title="购买时间" :columns="columns" :default-index="defa_flag" @cancel="onCancel" @confirm="onChange" show-toolbar/>
      </div>
    </div>
    <div class="class_dialog" v-if='zujian_flag'>
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{appname}}APP"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"' id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid="appid"
            :extinfo="JSON.stringify({'type': 1, 'spuID': dataList.spuId, 'orderSn': sn, 'owner': this.$route.query.owner, 'channel': this.$route.query.channel, 'orgn': this.$route.query.orgn})"
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
              </style>
              <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
          <span v-if='android' class="goapp"><a :href="scheme + '?type=1&sso_id='+ sso_id+'&orderSn='+ sn + '&spuID='+ goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
        </p>
      </div>
    </div>
    <arouse v-if="arshow" @arouse='receive'></arouse>
    <share v-if="isshare" @share='accept' :detailobj='detailobj'></share>
    <div class="BootDownload_bg" v-if="isAi"></div>
    <div class="BootDownload" :class="isClass ? 'wxapp' : ''" v-if="isAi">
      <div class="close" @click="aiclose"></div>
      <div class="h1" v-html="BootDownloadV1"></div>
      <div class="h2">{{subTitle}}</div>
      <div class="v3" v-if='isClass'>
        <div v-for="(item, index) in methods">{{item}}</div>
      </div>
      <div class="ewm" v-if='isClass'>
        <img :src="download_image" />
      </div>
      <div class="copy" @click="openAI">{{butName}}</div>
      <textarea id="textArea" style="display:none"></textarea>
    </div>


  </div>

</template>
<script>
import liveTip from "../livetip/index" //日历提醒
import addGroup from '../group/index' //加群
import courseInfo from "./courseinfo"; //课程介绍
import onlineCourse from "./onlineCourse"; //课程大纲
import leaf from "../leaf/index" //叶子节点
import coursePackage from "../coursePackages/index"; //课程配套
import popup from "../popup/index" //小程序弹窗
import arouse from '../arouse/index.vue'
import share from '../share/index'
import global_ from "../../global/index"
import wxapp from '../../utils/wxapp.js'
import { Icon, Tabs, Toast, Picker } from "vant";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import "vant/lib/icon/style";
import "vant/lib/tabs/style";
import "vant/lib/tab/style";
import "vant/lib/picker/style";
import moreCourses from "../moreCourses/index"; //更多课程
export default {
  data() {
    return {
      showbottomkefu: false,
      strongtip: false,
      strongwxlist: [],
      strongqqlist: [],
      isMember: false,
      wxQrcode: '',

      currentIndex: 0,
      isShow: false, //控制是否展开
      tabList: [
        {
          index: 0,
          value: "目录",
          show: true
        },
        {
          index: 1,
          value: "介绍",
          show: false
        },
        {
          index: 2,
          value: "课程配套",
          show: false
        },
        {
          index: 3,
          value: "更多推荐",
          show: true
        }
      ],
      dataList: [], //列表数据
      configList: [], //配置项数据
      remind: '',
      ticket: '',
      ticket_source: '',
      offsetTop: 0,
      isfixed: false,
      istitle: false,
      show_flag: true,
      applets_flag: false,
      scrollTop :0,
      interval:null,
      diffY:0,
      isShowFlag:false,
      hour: 0,
      level_count: 0,
      online_time: '',
      isLiveTip: false,
      count: 0,
      ua: navigator.userAgent.toLowerCase(),
      sn: this.$route.query.order_id,
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      isapplets: true,
      ticketObj: {},
      columns: [],
      system: [],
      option: false,
      defa_flag: 0,
      again: false,
      changeshop: false,
      sf: '',
      appid: '',
      sso_id: '',
      open_url: '',
      scheme: '',
      calendarList: [],
      zujian_flag: false,
      arshow: false,
      isshare: false,
      detailobj: {},
      introduce:'加入班群，获取优质资料',
      isClass: false,
      isAi: false,
      BootDownloadV1:'',
      subTitle: '',
      methods: [],
      download_url: 'http://www.eoffcn.com/wx_classonline/detail/?202308141704',
      download_image: '',
      butName: '',
      isIn: false,
      numberGoodsId: 0,
      hideFooter: navigator.userAgent.indexOf('hideFooter') > -1
    };
  },
  components: {
    liveTip,
    addGroup,
    courseInfo,
    onlineCourse,
    coursePackage,
    leaf,
    popup,
    Picker,
    arouse,
    share,
    moreCourses,
  },
  created() {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = false
      }
    })
    this.scrollEvent();
    if(localStorage.getItem('currentIndex')){
      this.currentIndex=localStorage.getItem('currentIndex');
    }
  },
  mounted() {
    localStorage.removeItem('currentIndex');
    wxapp.init()
    // window.addEventListener("scroll", this.initHeight);
    this.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      this.offsetTop = document.querySelector(".tabs").offsetTop;
    });
    if (this.$route.query.ticket) {
      this.checklogin()
    } else {
      this.getDetail()
      this.courselive()
    }
    this.sso_id = localStorage.getItem("ticketObj")?JSON.parse(localStorage.getItem("ticketObj")).sso_id:''
    this.sf = this.$route.query.sf
    let that = this
    setTimeout(function() {
      console.log(11111,that.sf)
    },1000)
    if (this.sf == 'zxkt') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'zgwx') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'sydw') {
      this.appid = 'wx4161c8d806017e0d'
      this.appname = '事业单位'
      this.scheme = 'shiyedanwei://'
      this.open_url = 'http://3min-class.offcn.com/videos/h5/download/institution/'
    } else if (this.sf == 'zgtk') {
      this.appname = '中公题库'
      this.scheme = 'zhonggongtiku://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
    } else if (this.sf == 'zgzsb') {
      this.appid = 'wx9487d9bc65834b47'
      this.appname = '中公专升本'
      this.scheme = 'zhonggongzhuanshengben://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_zsb/detail'
    } else if (this.sf == 'zgyljy'){
      this.appid = 'wxc7238886c470203e'
      this.appname = '中公医疗教育'
      this.scheme = 'zhonggongyiliaojiaoyu://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_yikao'
    } else if (this.sf == 'zgjsgc') {
      this.appname = '中公建设工程'
      this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
    } else if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
  },
  cancel_flag () {
    this.zujian_flag = false
  },
  destroyed() {
    window.removeEventListener("scroll", this.initHeight);
  },
  methods: {
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("使用APP体验更优");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      if (this.sf == 'sydw') {
        window.location.href ="https://xue.offcn.com/institution/";
      } else if (this.sf == 'zgwx') {
        window.location.href ="https://www.eoffcn.com/help/download/online_course.html";
      } else if (this.sf == 'zgzsb') {
        window.location.href ="https://www.offcnzsb.com/zg/scan/";
      } else {
        //判断iPhone|iPad|iPod|iOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
        } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
        }
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    courselive() {
      this.$api.COURSELIVE({
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        system_order_num: this.$route.query.order_id
      }).then((res) => {
        if (res.code == 0) {
          this.calendarList = res.data
          console.log(this.calendarList)
          new Swiper('.swiper-container', {
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,//修改swiper的父元素时，自动初始化swiper
            pagination: {
              el: '.swiper-pagination',
              type: 'fraction'
            }
          });
        } else if (res.code == 2) {
          this.$router.push({ path: "/" })
        }
      })
    },
    go_zhibo(item) {
      this.$api.GETCATALOG({
        system_order_num: item.system_order,
        package_id: item.course_id,
        coding: item.cid,
        menu_id: item.lesson_id
      }).then((res) => {
        if (res.code == 0) {
          let info = res.data.catalog.info
          if (item.lesson_type == 3) {
            if (item.learning_style && item.learning_style.indexOf(2) == -1) {
              this.detail = item
              this.detail.order_id = this.$route.query.order_id
              this.detail.package_id = item.course_id
              this.detail.cid = item.cid
              this.detail.shopid = this.dataList.spuId
              if (!this.isapplets) {
                this.applets_flag = true
              } else {
                this.zujian_flag = true
              }
            } else {
              location.href = item.url_liveshow
            }
            // this.$router.push({
            //   path: "/livevod",
            //   query: {
            //     order_id: item.system_order,
            //     package_id: item.package_id,
            //     cid: item.cid,
            //     unit_id: item.lesson_id,
            //     live_type: 1,
            //     module_type: 66,
            //     url: item.url_liveshow
            //   }
            // })
          } else if (item.lesson_type == 9) {
            if (item.learning_style && item.learning_style.indexOf(2) == -1) {
              this.detail = item
              this.detail.order_id = this.$route.query.order_id
              this.detail.package_id = item.course_id
              this.detail.cid = item.cid
              this.detail.shopid = this.dataList.spuId
              if (!this.isapplets) {
                this.applets_flag = true
              } else {
                this.zujian_flag = true
              }
            } else {
              if (item.start_time-3600 < new Date().getTime()/1000 && new Date().getTime()/1000 < item.end_time - 0 + 3600) {
                this.$router.push({
                  path: "/livevod",
                  query: {
                    order_id: item.system_order,
                    package_id: item.course_id,
                    cid: item.cid,
                    unit_id: item.lesson_id,
                    live_type: 3,
                    module_type: 6,
                    url: info.live_record_url
                  }
                })
              } else if (item.start_time - 3600 > new Date().getTime()/1000) {
                Toast("直播未开始");
              } else if ((item.end_time - 0 + 3600 < new Date().getTime()/1000) && item.offline_code) {
                this.$router.push({
                  path: "/livevod",
                  query: {
                    order_id: item.system_order,
                    package_id: item.course_id,
                    cid: item.cid,
                    unit_id: item.lesson_id,
                    module_type: 66,
                    url: info.live_record_url
                  }
                })
              } else {
                Toast("暂无回放");
              }
            }
          } else {
            if (!this.isapplets) {
              this.applets_flag = true
            } else {
              this.zujian_flag = true
              this.$nextTick(() => {
                var btn = document.getElementById('launch-btn')
                btn.addEventListener('launch', function(e) {
                  this.handleJudgeWechat(); //是否满足跳转app条件
                });
              })
            }
          }
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    onChange(value, index) {
      this.$router.push({ path: "/list/detail", query: { order_id: this.system[index] } });
      location.reload()
    },
    onCancel() {
      this.option = false
    },
    goBack() {
      //返回
      this.$router.go(-1);
    },
    back_shop () {
      var SERVER_BASE_URL
      if (process.env.NODE_ENV=='production') {
        SERVER_BASE_URL = global_.global.shop_online_url
      } else if (process.env.NODE_ENV=='testing') {
        SERVER_BASE_URL = global_.global.shop_test_url
      } else {
        SERVER_BASE_URL = global_.global.shop_local
      }
      location.href = SERVER_BASE_URL + '/goods/detail/' + this.dataList.goodsId + '?is_back=1'
    },
    change () {
      this.option = true
    },
    changeIndex(index) {
      this.currentIndex = index;
    },
    aiclose() {
      this.isAi = false;
    },
    openAI() {
      if (this.isClass) {
        navigator.clipboard.writeText(this.download_url).then(() => {
          alert("复制成功！")
        }).catch((err)=>{
          alert("复制失败！")
        })
      } else {
        window.location.href=this.download_url;
      }

    },
    getVersionCheck(goodsId) {
      let isType='h5';
      if (/(micromessenger)/i.test(navigator.userAgent)) {
        wx.miniProgram.getEnv((res)=>{
          if (res.miniprogram) {
            this.isClass=true;
            isType='wxapp';
          } else {
            this.isClass=false;
            isType='h5';
          }
        })
      } else {
        this.isClass=false;
        isType='h5';
      }
      let data = {
        app_id: "1",
        appsystem: isType,
        goodsId: goodsId,
      }
       this.$api
        .VERSIONCHECK(data)
        .then((res) => {
          if(res.code == 0) {
            let RE = res.data.markInRed;
            let str = res.data.title;
            str = str.replace(RE,'<b style=" color: red;">'+RE+'</b>');
            console.log(str, 'getVersionCheck');
            this.BootDownloadV1 = str;
            this.subTitle = res.data.subTitle;
            this.butName = res.data.name;
            this.methods = res.data.methods;
            this.download_url = 'http://www.eoffcn.com/wx_classonline/detail/?202308141704';
            this.isAi = res.data.isAi;
            this.download_image = res.data.download_image;
          }
        })
        .catch(() => {});
    }
    ,
    getDetail() {
      let childList = [];
      this.$api
        .GETDETAIL({
          system_order_num: this.$route.query.order_id,
          "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
          ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        })
        .then((res) => {
          if (res.code == 0) {
            console.log('++++++++++++++++++++')
            this.getOnlineKefu(res.data.goodsPriId,res.data.skuId);
            console.log('enter here')
            console.log(res.data, 'res.data')
            this.isIn = res.data.viewInfo ? res.data.viewInfo.isIn : false;
            this.getVersionCheck(res.data.numberGoodsId);
            console.log(res.data.numberGoodsId);
            this.numberGoodsId = res.data.numberGoodsId;
            if(this.$route.query.justBuy == 1){
              console.log('justBuy == 1')
              this.ongetMemberRights(res.data.goodsPriId,res.data.skuId);
            }
            var config_index = 0;
            if (res.data.config.list.length != "") {
              res.data.config.list = res.data.config.list.filter((item) => {
                if (item.key == 8 || item.key == 13) {
                  config_index ++
                }
                if (config_index == 2) {
                  window.sessionStorage.setItem("config", 2)
                }
                if (item.key != 5 && item.key != 6 && item.key != 7 && item.key != 11 && item.key != 1000 && item.key != 2000) {
                  return item;
                }
              });
              if (res.data.config.list.length > 0) {
                this.tabList[2].show = true;
                this.configList = res.data.config.list;
                this.introduce = res.data.mall_add_group.introduce;
              }
              if (JSON.stringify(res.data.add_group) != '{}') {
                this.remind = res.data.add_group_remind
              }
            }
            this.detailobj = {
              url: res.data.goodsShareURL,
              name: res.data.order_name,
              price: res.data.sellPrice,
              remainGiveCourseNum: res.data.remainGiveCourseNum,
              giveCourseNum: res.data.giveCourseNum,
              sn: this.$route.query.order_id
            }
            if (res.data.courseIntroduction) {
              this.tabList[1].show = true;
              if (localStorage.getItem('currentIndex')) {
                this.currentIndex = localStorage.getItem('currentIndex');
                localStorage.removeItem('currentIndex');
               }else {
                this.currentIndex = 0;
              }
            }
            if (res.data.list != '') {
              this.dataList = res.data;
              window.sessionStorage.setItem("goodsId", res.data.goodsId)
              for (i=0;i<res.data.orderByGoods.length;i++) {
                this.columns.push(res.data.orderByGoods[i].createdAt)
                this.system.push(res.data.orderByGoods[i].systemSn)
              }
              this.defa_flag = this.system.indexOf(this.$route.query.order_id)
              this.again = res.data.allowRepeatBuy == 0? false: true
              this.changeshop = res.data.orderByGoods.length > 1? true: false
              this.messageHandlers()
            } else {
              let that = this
              this.count ++
              if (this.count == 4) {
                this.$router.push({ path: "/index" });
              } else {
                setTimeout(function() {
                  that.getDetail()
                }, 2000)
              }
            }
            for (var i in this.dataList.list) {
              for (var j in this.dataList.list[i]) {
                console.log(this.dataList.list[i]);
                this.$set(this.dataList.list[i], "isShow", false);
                this.$set(this.dataList.list[i].list[i], "isShow", false);
                childList = this.dataList.list[i].list[i].list;
                this.hour = childList[i].hour
                this.level_count = childList[i].level_count
                this.online_time = childList[i].online_time
              }
            }
            for (var i in childList) {
              childList[i].isShow = false;
            }
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
        .catch(() => {});
    },
    getOnlineKefu(goodsid, skuid){
      this.$api
        .GETONLINECONSULTINFO({
          goods_id: goodsid,
          sku_id: skuid,
          source: 1
        })
        .then(res => {
          console.log(res)
          if(res.data.channelId && res.data.groupId){
            this.showbottomkefu = true;
            this.channelId = res.data.channelId;
            this.groupId = res.data.groupId;
          }

        })
    },
    // 去智齿咨询
    goZhichi(){
      window.open('https://offcn.sobot.com/chat/h5/v2/index.html?sysnum=020bd1a0655d4c5e9603b2d261018f6a&channelid='+ this.channelId+'&groupid='+ this.groupId, '_blank')
    },
    // 获取提醒
    ongetMemberRights(goodsid,skuid){
      this.$api
        .GETMEMBERRIGHTS({
          member_goods_id: this.$route.query.membergoodsid, //会员商品id
          sso_id: this.sso_id,
          goods_id: goodsid,
          sku_id: skuid,
        }).then(res => {
        console.log('++++++++++++++++++++++++++++++++')
        console.log('强提醒+弱提醒 => ',res)
        if(res.code == 0){
          if(res.data.groupInfo != undefined && (res.data.groupInfo || res.data.groupInfo.length > 0)){
            if(res.data.groupInfo.wxList.length > 0){
              this.$api.CHECKADDEDWORkUSER({
                phone: JSON.parse(localStorage.getItem("ticketObj")).phone,
              }).then(r => {
                if (!r.data.inWeCom) {
                  this.strongtip = true;
                  this.strongwxlist = res.data.groupInfo.wxList;
                  this.strongqqlist = res.data.groupInfo.qqList;
                };
              });
            }
          }
          // 会员卡
          if(!res.data.detail || JSON.parse(res.data.detail).wxQrCode == ''){
            this.isMember = false
          }else{
            this.wxQrcode = JSON.parse(res.data.detail).wxQrCode
            this.isMember = true
          }
        }
      })
    },
    show() {
      this.isShow = !this.isShow;
    },
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
        // console.log(scrollTop ,this.offsetTop,'top',this);
        // console.log('距离顶部高度', this.$refs.obtain.getBoundingClientRect().top)
       // if (scrollTop > this.offsetTop) {
        if(this.$refs.obtain.getBoundingClientRect().top<0){
        //为导航条设置fix
        this.isfixed = true;
        this.istitle = true;
      } else {
        //移除fixed
        this.isfixed = false;
        this.istitle = false;
      }
    },
    search_flag() {
      if(this.isIn){
        location.href = 'https://www.eoffcn.com/wx_classonline/detail/';
        return false;
      };
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zxkt' || this.sf == 'zgwx') {
          location.href = 'https://www.eoffcn.com/wx_classonline/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgtk') {
          location.href = 'https://www.eoffcn.com/zg_questions/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'sydw') {
          location.href = 'https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgzsb') {
          location.href = 'https://www.eoffcn.com/zg_zsb/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgyljy') {
          location.href = 'https://www.eoffcn.com/zg_yikao/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgky') {
          location.href = 'https://www.eoffcn.com/zg_postgraduate/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.dataList.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgjsgc') {
          this.openApp('https://www.zggcks.com/zg/2021jgapp/')
        } else if (this.sf == 'zgyouzhi'){
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    },
    close_bottom() {
      // this.show_flag = false
      this.isShowFlag=true;
    },
    popup() {
      this.applets_flag = false;
    },
    opentk () {
      this.applets_flag = true;
    },
    copy_applets () {
      var copytext = document.getElementById("copytext")
      copytext.select() // 选择对象
      document.execCommand("Copy") // 执行浏览器复制命令
      Toast("小程序名称复制成功，打开微信搜索小程序听课吧")
    },
    checklogin () {
      // window.localStorage.clear()
      this.$api.USERINFO({
        'offcn-ticket': this.$route.query.ticket
      }).then(res => {
        if (res.code == 0) {
          this.ticketObj = {
            'offcn-ticket': res.data.ticket,
            ticket_source: res.data.ticket_source,
            sso_id: res.data.sso_user_id,
            name: res.data.user_info.name,
            phone: res.data.user_info.username
          }
          window.localStorage.setItem("ticketObj", JSON.stringify(this.ticketObj))
          var that = this
          $.ajax({
            url: (process.env.NODE_ENV=='production' ? '//shop.eoffcn.com': '//shop.t.eoffcn.com') + '/api/user/get_sign?phone=' + JSON.parse(localStorage.getItem("ticketObj")).phone,
            type: 'get',
            success:function(res) {
              if (res.status == 0) {
                that.ticketObj.sign = res.data.sign
                window.localStorage.setItem("ticketObj", JSON.stringify(that.ticketObj))
              }
            }
          })
          this.getDetail()
          this.courselive()
          this.isLiveTip = true;
        } else {
          this.$router.push({ path: "/" });
        }
      })
    },
    scrollEvent(){
      let _this=this;
      if(!this.isShowFlag){
        window.onscroll = function(e) {
          _this.scrollTop =document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;　　
          let scrollHeight = $(document).height();　　
          let windowHeight = $(window).height();　　
          _this.scrollFunc();
          if (_this.scrollTop + windowHeight + 20 >= scrollHeight || _this.scrollTop == 0) {　// 滚动到顶部或者底部
              _this.show_flag=true;
          } else {
              _this.show_flag=false;
          }
          if (_this.interval == null) { // 未发起时，启动定时器，1秒1执行
              _this.interval = setInterval(function() {
                  _this.stopScroll();
              }, 1000);
          }
        }
      }
    },
    scrollFunc() {
       let scrollAction = {x: 'undefined',  y: 'undefined'},scrollDirection;
        if (typeof scrollAction.x == 'undefined') {
            scrollAction.x = window.pageXOffset;
            scrollAction.y = window.pageYOffset;
        }
        this.diffY = scrollAction.y - window.pageYOffset;
        if (this.diffY < 0) {
            scrollDirection = 'down';
        } else if (this.diffY > 0) {
            scrollDirection = 'up';
        }
        scrollAction.x = window.pageXOffset;
        scrollAction.y = window.pageYOffset;
    },
    stopScroll() {
      //当滚动停止时，两个计算的距离会相同，此时再执行相关操作
      if ($(window).scrollTop() == this.scrollTop) {
          clearInterval(this.interval);
          this.show_flag=true;
          this.interval = null;
      }
    },
    messageHandlers () {
      var obj = {
        spuId: this.dataList.goodsId,
        goodsName: this.dataList.order_name,
        sn: this.$route.query.order_id
      }
      var str = JSON.stringify(obj);
      // 批改商品
      if (this.dataList.goodsType == 2) {
        if(this.android){
          window.androidJS.correct();
        }
        if(this.ios){
          window.webkit.messageHandlers.correct.postMessage('1');
        }
      } else {
        if (this.ua.match(/MicroMessenger/i)=="micromessenger") {
          wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
              wx.miniProgram.navigateTo({ url: '/pages/lessondetail/lessondetail?id='+ this.$route.query.order_id })
            }
          })
        } else if (this.ios) {
          console.log('ios 执行跳转')
          if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goToCourseDetail) {
            window.webkit.messageHandlers.goToCourseDetail.postMessage(str);
            return false;
          } else {
            window.webkit.messageHandlers.goToStudy.postMessage(str);
            return false;
          }
        } else {
          console.log(2222222222, obj)
          if (window.androidJS && window.androidJS.goToCourseDetail) {
            window.androidJS.goToCourseDetail(str);
            return false;
          } else {
            window.androidJS.goToStudy(str);
            return false;
          }
        }
      }
    },
    receive (val) {
      this.arshow = val
    },
    // 赠送好友
    accept (val) {
      this.isshare = val
    },

    // 跳转到微信小程序中间页
    goWxapp(qrimg){
      this.strongtip = false;
      window.open('https://cloud1-9gm1jh9440f32a57-1305285725.tcloudbaseapp.com/gocontact.html?type=0&groupLinkImg='+qrimg, '_blank')
    },
  }
};
</script>
<style lang="less" scoped>
.BootDownload_bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background-color: #000;
    opacity: 0.6;
}
.BootDownload{
    width: 100%;
    height: 418px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 100000;
    background: url(https://statics.eoffcn.com/statics/iconAI/H5-BJ@2x.png) no-repeat center bottom;
    background-size: 100%;
    overflow: hidden;
    border-radius: 25px 25px 0 0;
    box-sizing: border-box;
    padding: 0 50px;
    padding-top: 80px;
}
.BootDownload.wxapp{
    width: 100%;
    height: 764px;
    background: url(https://statics.eoffcn.com/statics/iconAI/xcx2x.png) no-repeat center bottom;
    background-size: 100%;
}
.BootDownload .close{
    width: 32px;
    height: 32px;
    position: absolute;
    top: 20px;
    right: 20px;
    margin: auto;
    background: url(https://statics.eoffcn.com/statics/iconAI/gb2x.png?202307121807d) no-repeat center bottom;
    background-size: 100%;
    overflow: hidden;
}
.BootDownload .h1{
    font-weight: bold;
    font-size: 38px;
    line-height: 45px;
    margin-bottom: 25px;
}
.BootDownload .h2,.BootDownload .v3{
    width:520px;
    font-size: 28px;
    line-height: 35px;
    margin-bottom: 10px;
}
.BootDownload .copy {
    width: 450px;
    height: 80px;
    display: block;
    overflow: hidden;
    text-align: center;
    line-height: 80px;
    border-radius: 80px;
    margin: auto;
    position: absolute;
    left: 0;
    font-size: 32px;
    color: #fff;
    right: 0;
    bottom: 75px;
    background-color: #e9463d;
    background: linear-gradient(to right, #e9463d, #e7292f);
}
.BootDownload .ewm{
    width: 220px;
    height:220px;
    border-radius: 32px;
    overflow: hidden;
    margin-top: 20px;
    background-color: #666666;
}
.BootDownload .ewm img{
    width: 220px;
    border-radius: 32px;
    display:block;
}
/deep/ .van-picker-column__item--selected {
  color: #db3021;
}
.detail-wrapper {
  min-height: 100vh;
  margin: 0 auto;
  background: #ffffff;
  position: relative;
  .fixed-kefu {
    position: fixed;
    bottom: 250px;
    right: 0;
    width: 134px;
    height: 134px;
    z-index: 2;
    .zhichi-img {
      width: 134px;
      height: 134px;
    }
  }
  .online_time {
    color: #999999;
    margin-top: 20px;
  }
  .header {
    padding: 30px 35px 0 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
    position: fixed;
    width: 100%;
    z-index: 2;
    > div {
      display: flex;
    }
    .shop_detail img {
      width: 60px;
      height: 48px;
    }
    .consulting {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #333333;
    }
    .top_title {
      width: 554px;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .give {
      width: 80px;
	    height: 60px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  section {
    width: 100%;
    position: absolute;
    top: 60px;
  }
  .banner {
    padding: 0 30px;
    img {
      width: 100%;
      height: 390px;
    }
  }
  .live_options {
    padding: 0 30px;
    .swiper-container {
      .swiper-slide {
        p {
          position: absolute;
          font-size: 28px;
          margin-top: 10px;
          margin-left: 10px;
          img {
            width: 100px;
          }
        }
        .livetipname {
          display: inline-block;
          width: 62%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .poster {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .title-box {
    position: relative;
    width: 100%;
    padding: 30px;
    .buy_again {
      position: fixed;
      // bottom: 70px;
      top: 35%;
      z-index: 1;
      right: 0;
      width: 126px;
	    height: 48px;
      text-align: center;
      line-height: 48px;
      color: #ffffff;
      border-radius: 24px 0px 0px 24px;
      z-index: 1000;
      background: linear-gradient(90deg, #dc3021 0%, #e6422c 50%, #ef5437 100%), linear-gradient(#ea644e, #ea644e);
    }
    .title {
      font-size: 36px;
      font-weight: bold;
      color: #333;
      line-height: 1.3;
    }
    .text_overflow{
      display: flex;
      align-items: center;
      i {
        margin-left: 10px;
      }
    }
    .goumai_time {
      margin-top: 16px;
      color: #999;
      .qihuan_time {
        margin-left: 10px;
        color: #e60012;
        img {
          margin-left: 8px;
          vertical-align: middle;
        }
      }
    }
    .opening-time {
      width: 100%;
      font-size: 22px;
      margin-top: 16px;
      color: #999;
      position: relative;
      min-height: 35px;
      padding-right: 60px;
      &.show {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      > span {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }
  .advice {
    width: 37px;
    height: 34px;
  }
  .share {
    width: 33px;
    height: 33px;
  }
  .content {
    width: 100%;
    margin-top: 15px;
    padding-bottom: 100px;
  }
  .tab_margin {
    height: 10px;
    background: #f5f5f5;
  }
  .tab-box {
    background: #fff;
    .tabs {
      width: 100%;
      padding: 0 30px;
      color: #666;
      font-size: 28px;
      font-weight: 28px;
      height: 90px;
      line-height: 90px;
      background: #ffffff;
      span {
        margin-right: 45px;
        font-weight: bold;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          color: #333;
          font-size: 32px;
          &::after {
            content: "";
            background-color: #e60012;
            width: 40px;
            height: 5px;
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: -14px;
          }
        }
      }
    }
  }
  .fixed {
    position: fixed;
    top: 100px;
    left: 0;
    border-bottom: 1px solid#e6e6e6;
    z-index: 1;
  }
  .fixeds {
    position: fixed;
    top: 0;
    left: 0;
    border-bottom: 1px solid#e6e6e6;
    z-index: 1;
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 98px;
    padding: 0 20px;
    border-radius: 20px 20px 0px 0px;
    background-image: linear-gradient(90deg, #d33f3a 0%,#d75b4a 100%), linear-gradient(#333333, #333333);
    .bottom_text {
      display: flex;
      align-items: center;
      color: #ffffff;
    }
    img {
      width: 30px;
      margin-right: 12px;
    }
    p {
      a {
        display: inline-block;
        height: 58px;
        text-align: center;
        line-height: 58px;
        font-size: 24px;
        border-radius: 30px;
      }
    }
    .footer_btn {
      width: 170px;
      color: #ffffff;
      border: 1px solid #ffffff;
    }
    .footer_btns {
      width: 140px;
      color: #e60012;
      background:#ffffff;
      margin-left: 20px;
    }
    z-index: 10000px;
  }
  .open_applets_mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 2;
    .open_applets_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 500px;
      transform: translate(-50%, -50%);
      text-align: center;
      .open_applets {
        padding: 50px 0;
        color: #666666;
        background: #ffffff;
        border-radius: 20px;
        .qrcode_img {
          width: 400px;
          height: 400px;
          margin-bottom: 20px;
        }
        .save_qrcode {
          font-size: 22px;
          margin: 10px 86px 0;
        }
        .copy_name {
          width: 400px;
          line-height: 60px;
          font-size: 26px;
          color: #ffffff;
          background: #e60012;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  .buyshop_time {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 2;
    .time_picker {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      max-height: calc(100% - 33.3%);
      background: #ffffff;
      border-radius: 30px 30px 0px 0px;
    }
  }
  .sf {
    display: none;
  }
  .class_dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 2;
    .dialog_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      line-height: 40px;
      border-radius: 18px;
      transform: translate(-50%, -50%);
      background: #fff;
      .dialog_message {
        text-align: center;
        padding: 30px 30px;
      }
      p {
        display: flex;
        border-top: 1px solid #e5e5e5;
        height: 70px;
        line-height: 70px;
        span {
          flex: 1;
          text-align: center;
        }
        .goapp {
          color: #e60012;
          border-left: 1px solid #e5e5e5;
        }
      }
    }
  }
  .config_mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: rgba(0, 0, 0, .7);
    .config_content {
      position: absolute;
      bottom: 0;
      width: 100%;
      max-height: 1000px;
      background: #ffffff;
      padding: 38px 30px;
      border-radius: 30px 30px 0px 0px;
      overflow-y: scroll;
      .config_title {
        font-size: 32px;
        font-weight: bold;
        color: #333333;
        img {
          float: right;
        }
      }
      .config_detail {
        .cid_name {
          margin-top: 50px;
          text-align: center;
          font-size: 28px;
          font-weight: bold;
          color: #333333;
        }
        .warn_mes {
          text-align: center;
          color: #666666;
          margin-top: 20px;
        }
        .qq_config {
          height: 130px;
          background: #f6f6f6;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          margin-top: 30px;
          .qq_group {
            display: flex;
            align-items: center;
            img {
              width: 70px;
              height: 70px;
              margin-right: 20px;
            }
            .qq_name {
              font-size: 26px;
              font-weight: bold;
            }
          }
        }
        .qq_text {
          position: absolute;
          opacity: 0;
        }
        .copy {
          width: 160px;
          height: 56px;
          text-align: center;
          line-height: 56px;
          background: #ffffff;
          color: #e60012;
          border: 1px solid #e60012;
          border-radius: 8px;
        }
        .get_ziliao {
          height: 78px;
          text-align: center;
          line-height: 78px;
          font-size: 30px;
          color: #ffffff;
          background: linear-gradient(90deg, #dc3021 0%, #e6422c 50%, #ef5437 100%), linear-gradient(#ec533d, #ec533d);
          border-radius: 40px;
          margin-top: 30px;
        }
        .out_loop {
          text-align: center;
          .img_link {
            width: 240px;
            height: 240px;
            margin-top: 30px;
          }
          .wenan {
            font-size: 30px;
            color: #e60012;
            margin-top: 30px;
          }
          .weixin_img {
            position: relative;
            .hand {
              position: absolute;
              bottom: -20px;
              width: 45px;
              height: 46px;
            }
          }
          .go_wxapp_btn {
            width: 640px;
            height: 78px;
            margin-left: auto;
            margin-right: auto;
            line-height: 78px;
            text-align:center;
            background: linear-gradient(to right,#dc3021,#ef5437);
            font-size: 28px;
            color: #fff;
            font-weight: bold;
            border-radius: 39px;
          }
        }
      }
    }
  }
  .member-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 3;
    .member-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 500px;
      text-align: center;
      border-radius: 8px;
      background: #ffffff;
      padding: 30px 0;
      .kf_title {
        font-size: 30px;
        img {
          position: absolute;
          top: 30px;
          right: 30px;
        }
      }
      .kf_content {
        margin-top: 20px;
      }
      .member_img {
        width: 250px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/detail.vue